import React, { FC, useMemo } from 'react';
import Image from 'next/image';
import { TextBlock } from '../../uicomp/atmos/content-block/ContentBlock';
import styles from './CvTemplate.module.less';
import Temp1 from '../../public/cvTemplate/template1.png';
import Temp2 from '../../public/cvTemplate/template2.jpeg';
import Temp3 from '../../public/cvTemplate/template3.jpeg';
import Temp4 from '../../public/cvTemplate/template4.jpeg';
import Temp5 from '../../public/cvTemplate/template5.png';
import Temp6 from '../../public/cvTemplate/template6.png';
import Temp7 from '../../public/cvTemplate/template7.png';
import Temp8 from '../../public/cvTemplate/template8.png';
import Temp9 from '../../public/cvTemplate/template9.png';
import Temp10 from '../../public/cvTemplate/template10.png';
import Temp11 from '../../public/cvTemplate/template11.png';
import Temp12 from '../../public/cvTemplate/template12.png';
import Temp13 from '../../public/cvTemplate/template13.png';
import Temp14 from '../../public/cvTemplate/template14.png';
import Temp15 from '../../public/cvTemplate/template15.png';
import Temp16 from '../../public/cvTemplate/template16.png';
import Temp17 from '../../public/cvTemplate/template17.png';
import Temp18 from '../../public/cvTemplate/template18.png';
import Temp19 from '../../public/cvTemplate/template19.png';
import Temp20 from '../../public/cvTemplate/template20.png';
import Temp21 from '../../public/cvTemplate/template21.png';

type Props = {
  title?: string;
  onClick?: () => void;
  selected?: boolean;
};
export const TemplateSelectBox: FC<Props> = ({ title, selected, onClick }) => {
  const getImage = useMemo(() => {
    if (title && title === 'Template 2') {
      return Temp2;
    }
    if (title && title === 'Template 3') {
      return Temp3;
    }
    if (title && title === 'Template 4') {
      return Temp4;
    }
    if (title && title === 'Template 5') {
      return Temp5;
    }
    if (title && title === 'Template 6') {
      return Temp6;
    }
    if (title && title === 'Template 7') {
      return Temp7;
    }
    if (title && title === 'Template 8') {
      return Temp8;
    }
    if (title && title === 'Template 9') {
      return Temp9;
    }
    if (title && title === 'Template 10') {
      return Temp10;
    }
    if (title && title === 'Template 11') {
      return Temp11;
    }
    if (title && title === 'Template 12') {
      return Temp12;
    }
    if (title && title === 'Template 13') {
      return Temp13;
    }
    if (title && title === 'Template 14') {
      return Temp14;
    }
    if (title && title === 'Template 15') {
      return Temp15;
    }
    if (title && title === 'Template 16') {
      return Temp16;
    }
    if (title && title === 'Template 17') {
      return Temp17;
    }
    if (title && title === 'Template 18') {
      return Temp18;
    }
    if (title && title === 'Template 19') {
      return Temp19;
    }
    if (title && title === 'Template 20') {
      return Temp20;
    }
    if (title && title === 'Template 21') {
      return Temp21;
    }
    return Temp1;
  }, [title]);
  return (
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions
    <div
      onClick={() => {
        onClick?.();
      }}
      style={{ marginTop: '10px' }}
      className={styles.tBoxBody}>
      <div className={selected ? styles.selectedColorBox : undefined}>
        <Image height={200} width={150} src={getImage} alt={'Template'} />
      </div>
      {title && <TextBlock>{title}</TextBlock>}
    </div>
  );
};
